<template>
    <div v-on:keydown="handleKeydown" style="width: 100%; padding: 12px 0;">
      <el-row type="flex" justify="start" align="middle" style="padding: 3px 0;">
        {{ title }}
      </el-row>
      <el-row type="flex" justify="center" align="middle">
        <el-form :model="form" ref="headerForm" style="width: 100%;">
          <table style="margin: 0;">
            <col width="120 ">
            <col width="200">
            <tr v-for="(f, index) in fields.inputFields" v-if="!f.hidden">
              <td>
                {{ f.required ? `*${f.label || f.name }` : (f.label || f.name )}}
              </td>
              <td style="text-align: left;" :class="`${(f.fieldError && (errorField === f.name))  ? 'bg-danger' : ''}`">
                <el-input
                  data-type="input"
                  :class="`keynav${f.required ? ' text-input_required' : ''}`"
                  v-if="form && f.fieldType === 'input' && !f.autocomplete"
                  v-model="form[f.name]"
                  :ref="`${idPrefix}${index + 1}`"
                  :id="idPrefix + (index + 1)"
                  :name="f.name"
                  :disabled="f.disabled || isSaving"
                  @blur="fieldFocusChanged"
                  @change="() => change(f.name)"
                />
                <MoneyField
                  data-type="input"
                  style="padding-left: 12px;"
                  v-model="form[f.name]"
                  class="keynav"
                  v-if="form && f.fieldType === 'money' && !f.hidden"
                  :id="idPrefix + (index + 1)"
                  :ref="`${idPrefix}${index + 1}`"
                  :name="f.name"
                  :disabled="f.disabled || isSaving"
                  :required="f.required"
                  @blur="() => change(f.name)"
                  @change="() => change(f.name)"
                />
                <el-autocomplete
                  data-type="autocomplete"
                  :class="`keynav${f.required ? ' autocomplete-input_required' : ''}`"
                  placeholder="Type to search..."
                  @select="(selection) => handleAutocompleteChange(selection, f.name)"
                  :ref="`autocomplete__${idPrefix}${index + 1}`"
                  :id="idPrefix + (index + 1)"
                  :name="f.name"
                  :fetch-suggestions="(query, cb) => f.searchAsync
                    ? querySearchAsync(f.name, f.queryData, query, cb)
                    : querySearch(f, query, cb)"
                  :props="{ label: 'label', value: 'value' }"
                  :trigger-on-focus="f.triggerOnFocus"
                  v-else-if="form && f.fieldType === 'input' && f.autocomplete"
                  v-model="form[f.name].label"
                  :disabled="f.disabled || isSaving"
                  @change="() => change(f.name)"
                  @input="(value) => handleAutocompleteChange(value || { label: '', [f.name]: '' }, f.name)"
                />
                <el-select
                  data-type="select"
                  class="keynav"
                  :ref="`${idPrefix}${index + 1}`"
                  :id="idPrefix + (index + 1)"
                  :name="f.name"
                  :filterable="f.filterable"
                  :multiple="f.multiple"
                  :loading="null"
                  :placeholder="f.filterable ? 'Search' : 'Select option'"
                  :disabled="f.disabled || isSaving"
                  v-else-if="form && f.fieldType === 'select' && f.name !== 'period'"
                  @change="() => change(f.name)"
                  v-model="form[f.name]">
                  <el-option v-for="item in f.options" :key="item.value" :label="item.label" :value="item.value">
                    {{ item.label }}
                  </el-option>
                </el-select>
                <el-select
                  data-type="select"
                  class="keynav"
                  :ref="`${idPrefix}${index + 1}`"
                  :id="idPrefix + (index + 1)"
                  :name="f.name"
                  :filterable="f.filterable"
                  :multiple="f.multiple"
                  :loading="null"
                  :placeholder="f.filterable ? 'Search' : 'Select option'"
                  :disabled="f.disabled || isSaving"
                  v-else-if="form && f.fieldType === 'select' && f.name === 'period'"
                  @change="() => change(f.name)"
                  v-model="form[f.name]">
                  <el-option v-for="item in f.options" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
                <el-checkbox
                  data-type="checkbox"
                  class="keynav form-checkbox"
                  :ref="`${idPrefix}${index + 1}`"
                  :id="idPrefix + (index + 1)"
                  :name="f.name"
                  :disabled="f.disabled || isSaving"
                  v-else-if="form && f.fieldType === 'checkbox'"
                  v-model="form[f.name]"
                  @change="() => change(f.name)"
                />
                <DateField
                  class="keynav"
                  :id="`${idPrefix}${index + 1}`"
                  :name="f.name"
                  :disabled="f.disabled || isSaving"
                  :ref="`${idPrefix}${index + 1}`"
                  :dataoptions="{ 'data-type': 'date' }"
                  :required="f.required"
                  v-model="form[f.name]"
                  v-else-if="form && f.fieldType === 'date'"
                  @change="() => change(f.name)"
                />
              </td>
              <td v-if="f.addBtn" width="30px;">
                <div style="text-align: center;">
                  <el-button class="keynav" tabindex="-1" size="mini" @click="openCreateModal(f.name)" icon="plus" />
                </div>
              </td>
            </tr>
            <tr v-if="fields.displayFields" v-for="d in fields.displayFields">
              <td>
                <div style="padding: 3px;">{{ d.label }}</div>
              </td>
              <td>
                <div v-if="d.specialCell" style="text-align: left; color: gray; padding: 0 6px;">
                  <el-col :span="24">
                    <SpecialCell
                      :displayValue="d.value"
                      :btnLabel="specialCellBtnLabel"
                      :showBtn="parseInt(d.value) > 0"
                      v-on:specialCellBtnClick="$emit('specialCellBtnClick')"
                    />
                  </el-col>
                </div>
                <div v-else-if="d.value" style="text-align: left; color: gray; padding: 0 6px;">
                  {{
                    (form && form[d.name] && form[d.name].value)
                    ? d.value
                    : ''
                  }}
                </div>
                <div v-else style="text-align: left; color: gray; padding: 0 6px;">
                  {{
                    (form && form[d.name] && form[d.name].value)
                      ? getDisplayValue(d.getter, form[d.name].value, d.propToDisplay, d.customFunc)
                      : ''
                  }}
                </div>
              </td>
            </tr>
            <tr v-for="j in fields.existingModelFields">
              <td>
                <div style="padding: 3px;">{{ j.label }}</div>
              </td>
              <td>
                <div v-if="j.name && j.name === 'runningTotal'" style="text-align: left; color: gray; padding: 0 6px;">
                  {{ j.prefix ? j.prefix : '' }}{{ formatAmountLocale(calculateRunningTotal) }}
                </div>
                <div v-else style="text-align: left; color: gray; padding: 0 6px;">
                  {{ j.prefix ? j.prefix : '' }}{{ form && j.useFormValue && j.field ? (j.field.includes('decimal') ? formatAmountLocale(form[j.field]) : form[j.field]) : j.value }}
                </div>
              </td>
            </tr>
          </table>
        </el-form>
      </el-row>
    </div>
  </template>
  
  <script>
    /* eslint-disable no-unused-vars */
    import { mapGetters } from 'vuex'
    import validFormFields from '@/utils/validElementFormInputs'
    import { navigateHeader } from '@/utils/helpers/NavigateForm'
    import filterInvalidDOMElements from '@/utils/helpers/FilterInvalidDOMElements'
    import buildAddressString from '@/utils/helpers/BuildAddressString'
    import buildNoDataObject from '@/utils/helpers/BuildNoDataObject'
    import buildLabelString from '@/utils/helpers/BuildLabelString'
    import getNextLetter from '@/utils/helpers/GetNextLetter'
    import { flattenArrayRecursive } from '@/utils/helpers/FlattenArray'
    import { hideOpenSuggestionMenus, shouldDisableArrowNav, handleTabKey } from '@/utils/helpers/DataEntryViews/ArrowNavHelper'
    import SpecialCell from './SpecialCell.vue'
    import MoneyField from '@/components/InputComponents/MoneyField.vue'
    import DateField from '@/components/InputComponents/DateField.vue'
    import { formatAmount } from '@/utils/helpers/AmountFormatter'

    export default {
      components: {
        SpecialCell,
        MoneyField,
        DateField
      },
      props: {
        title: String,
        fields: Object,
        lines: Array,
        form: Object,                               // When multiple instances of this component are loaded in the DOM, it is necessary to
        idPrefix: String,                           // <--- pass an id prefix in order to prevent duplicate ids in the DOM. Whatever prefix you pass,
        nonAsyncSuggestions: Object,                // be sure to append a '-' (dash) to it (i.e. "a-") so that navigateForm() works for each instance.
        formChanged: Boolean,
        isSaving: Boolean,
        specialCellBtnLabel: String,
        transactionType: {
          type: String,
          required: false,
          default: undefined
        },
        linesContainReliefLines: Boolean
      },
      data () {
        return {
          suggestions: {
            active: '',
            account: [],
            address_id: [],
            address_billing: [],
            address_contact: [],
            address_physical: [],
            address_mailing: [],
            batch: [],
            currency: [],
            customer: [],
            parent: [],
            period: [],
            source_code: [],
            vendor: [],
            limit_to_bid: []
          },
          loading: false,
          suppressKeyNav: false,
          searchTimeout: null,
          previousVendorSelection: null,
          errorField: null
        }
      },
      methods: {
        formatAmountLocale (amount) {
          return formatAmount(amount)
        },
        openCreateModal (name) {
          if (name === 'vendor' || name === 'customer') {
            this.$store.dispatch('changeModalVisibility', { entityType: 'customerVendorForm', visible: true, inDataEntryView: true, type: name })
          } else {
            this.$store.dispatch('changeModalVisibility', { entityType: name, visible: true, inDataEntryView: true })
          }
        },
        getDisplayValue (getter, id, propToDisplay, customFunc = null) {
          if (!getter) {
            return ''
          }
          const model = this.$store.getters[getter](id)
          if (model && model.hasOwnProperty(propToDisplay)) {
            if (customFunc) {
              return customFunc(model[propToDisplay]) || 'Not specified'
            }
            return model[propToDisplay] || 'Not specified'
          }
        },
        change (fieldName) {
          this.$emit('formChanged', this.form, fieldName)
        },
        getFieldName () {
          return document.activeElement.name
        },
        handleKeydown (e) {
          if (this.suppressKeyNav) {
            e.preventDefault()
            return
          }
          const fieldName = this.getFieldName()
          if (!fieldName) return
          if ([37, 38, 39, 40, 13].includes(e.keyCode)) {
            this.navigateForm(e)
            this.checkFormField(fieldName)
          } else if (e.keyCode === 9) {
            handleTabKey(this)
            this.checkFormField(fieldName)
          } else {
            this.checkIfValueShouldBeReset(fieldName)
            this.checkFormField(fieldName)
            if (e.keyCode === 8) {                                                                         // Emit event when clearing an autocomplete field
              let f = flattenArrayRecursive(Object.values(this.fields))
              if (f && f.length) f = f.find(v => v.name === fieldName)
              if (f && f.hasOwnProperty('autocomplete') && f.autocomplete) this.$emit('acBackspaceEvent')
            }
          }
        },
        checkIfValueShouldBeReset (fieldName) {
          let field = this.form[fieldName]
          if (field && field.hasOwnProperty('value')) {
            const existing = this.getHeaderFieldByName(fieldName)
            if (existing && Object.keys(existing).length && (existing.label !== field.label)) {
              field.value = ''
            }
          }
        },
        checkFormField (fieldName) {
          const field = this.form[fieldName]
          const fieldMeta = Object.values(this.fields.inputFields).find(v => v.name === fieldName)
          if (field && field.hasOwnProperty('value') && fieldMeta && fieldMeta.required) {
            if (!field.value) {
              document.getElementsByName(fieldName)[0].style.backgroundColor = '#ff49493d'                    // Set color to indicate that value has been set
            } else {
              document.getElementsByName(fieldName)[0].style.backgroundColor = '#e2f0f5'                      // Set color to indicate that value has been set
            }
          }
        },
        navigateForm (e) {
          if (shouldDisableArrowNav(this, e)) return false
          hideOpenSuggestionMenus(this)                                                                       // --- Hide any open suggestion menus before navigating to next field
          const id = e.srcElement.closest('.keynav').className.includes('el-select')                          // --- See ** below, because el-selects are a pain in the arse
            ? e.srcElement.closest('.el-input').id                                                            //
            : e.srcElement.closest('.keynav').id                                                              //
          const idParts = id.split('-')                                                                       // --- Each form element has a unique id consisting of a prefix letter and a number. This separates the id
          const idPrefix = idParts[0]                                                                         //     into an array containing the prefix at index 0...
          const idNum = parseInt(idParts[1])                                                                  //     and the number at index 1
          const targetId = navigateHeader(e, idNum, (Math.round(this.fields.length / 2)), 2)               // --- This gets the id of the element the user is trying to navigate to (targetId), which depends on the key
          let elsFoundById = document.getElementById(`${idPrefix}-${targetId}`)
          let els
          if (elsFoundById && elsFoundById.children.length) {
            els = elsFoundById.getElementsByTagName('*')                                         // --- Once we have the target id, we can select the element it's assigned to, and (because of Element-UI)....
          } else if (elsFoundById && elsFoundById.tagName === 'INPUT') {
            return elsFoundById.focus()
          } else {                                                                                            // look for element with next id prefix type. i.e. if previous is a-, look for anything with b-1
            e.preventDefault()
            const newPrefix = getNextLetter(idPrefix)                                                         // --- If no elements were found using idPrefix, get the next letter and use that as the new id prefix
            let newId = document.querySelector(`[id^="${newPrefix}-"]`) ? document.querySelector(`[id^="${newPrefix}-"]`).id : null
            let nextSection
            if (newId) {
              nextSection = document.getElementById(newId)
            } else {
              nextSection = document.getElementById(`${newPrefix}-1`)
            }
            if (nextSection) {
              els = nextSection.getElementsByTagName('*')
            } else {
              return
            }
          }
          const validEls = filterInvalidDOMElements(els, validFormFields)                                     //     filter children that *aren't* input elements (<input>, <select>, <checkbox>, etc.)...
          this.fieldFocusChanged()
          if (validEls[0]) {
            validEls[0].focus()
          }
        },
        // TODO: you need to review this. Without this code, the MoneyField component will not round 1000.5099 to 1000.51.
        // TODO: even though it probably should do that...Check and create an issue for this?
        fieldFocusChanged () {
          // this.changeDollarAmtsToDecimal()
        },
        changeDollarAmtsToDecimal () {
          let moneyFields = Object.values(this.fields.inputFields).filter(v => v.isMoney)
          const { form } = this
          for (let i = 0; i < moneyFields.length; i++) {
            const name = moneyFields[i].name
            if (form[name] && typeof parseFloat(form[name]) === 'number') {
              this.form[name] = Number(form[name]).toFixed(2)
            }
          }
        },
        /**
         * Handles non-remote searches for autocomplete fields
         * @param field       The field definition object
         * @param query       The user's search query
         * @param cb          A callback that handles ElementUI displaying of results
         */
        querySearch (field, query, cb) {
          this.clearActiveSuggestionListIndicator()
          let results = (query && field) ? field.options.filter(this.createFilter(query)) : field.options
          cb(results)
        },
        /**
         * Handles remote searches for autocomplete fields
         * @param fieldName   The name of the autocomplete field
         * @param queryData   An object consisting of an endpoint and pre-set query string params to use when searching
         * @param query       The user's search query
         * @param cb          A callback that handles ElementUI displaying of results
         */
        querySearchAsync (fieldName, { endpoint, params = {} }, query, cb) {
          if (!endpoint) {
            throw new Error('Missing endpoint for autocomplete remote search.')
          }
          const executeSearch = () => {
            this.clearActiveSuggestionListIndicator('')
            let results = query ? this.suggestions[fieldName].filter(this.createFilter(query, fieldName)) : this.suggestions[fieldName]
            if (!(query && query !== '' && query.length >= 1)) {
              return
            }
            this.$store.dispatch('searchWithQuery', { endpoint, query: { search: query, ...params } })
              .then(r => {
                this.loadingOptions = false
                if (r && r.count) {
                  results = Object.values(r.entities[endpoint]).map(v => {
                    let ret = {}
                    ret.label = fieldName !== 'addresses' ? buildLabelString(v) : buildAddressString(v)
                    ret[fieldName] = v.id
                    return ret
                  })
                  this.setActiveSuggestionListIndicator(fieldName, true)
                  cb(results)
                } else {
                  cb([buildNoDataObject(fieldName)])
                }
              })
              .then(() => {
                const { $refs } = this
                for (let r in $refs) {
                  if (r.includes('autocomplete') && $refs[r][0] && $refs[r][0].suggestions.length) {
                    this.$refs[r][0].highlight(0)
                  }
                }
              })
              .catch(e => {
                console.log(e)
                cb([buildNoDataObject(fieldName)])
              })
          }
          if (this.searchTimeout) clearTimeout(this.searchTimeout)
          this.searchTimeout = setTimeout(() => executeSearch(), 300)
        },
        createFilter (query, fieldName) {
          return (link) => {
            return (link[fieldName].indexOf(query.toLowerCase()) === 0)
          }
        },
        setActiveSuggestionListIndicator (field, asyncSuggestionList) {
          asyncSuggestionList ? this.suggestions.active = field : this.nonAsyncSuggestions.active = field
        },
        clearActiveSuggestionListIndicator () {
          if (this.suggestions) this.suggestions.active = ''
          if (this.nonAsyncSuggestions) this.nonAsyncSuggestions.active = ''
        },
        /**
         * Handles changes to autocomplete fields. this.checkFormField verifies that the selection is valid
         * @param selection
         * @param targetFieldName
         * @param skipVendorCheck
         */
        handleAutocompleteChange (selection, targetFieldName, skipVendorCheck = false) {
          if (targetFieldName === 'vendor' && !skipVendorCheck) {
            this.handleVendorChange(selection)
            return
          }
          if (selection.label === 'No data' && !selection[targetFieldName]) {
            this.form[targetFieldName] = Object.assign({}, { label: '', value: '' })
            return selection.label
          }
          this.form[targetFieldName] = {
            label: selection.hasOwnProperty('label') ? selection.label : selection,
            value: selection.hasOwnProperty(targetFieldName) ? selection[targetFieldName] : ''
          }
          this.checkFormField(targetFieldName)
          this.$store.dispatch('setHeaderForm', { [targetFieldName]: { ...this.form[targetFieldName] } })
          this.$emit('formChanged', this.form, targetFieldName)
          return selection.label
        },
        /**
         * Displays a dialog box that informs the user that some lines are relief lines and prompts the user to confirm
         * whether they wish to change vendors.
         * @param selection   The new vendor selection
         */
        async handleVendorChange (selection) {
          if (this.linesContainReliefLines) {
            try {
              await this.$confirm('There are currently relief lines associated with this vendor. Changing vendors will remove the selected PO relief information. Proceed?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning',
                closeOnClickModal: false,
                closeOnPressEscape: false
              })
              this.handleAutocompleteChange(selection, 'vendor', true)
              this.previousVendorSelection = { label: selection.label, value: selection.vendor }
            } catch (e) {
              this.form.vendor = { ...this.previousVendorSelection }
              this.checkFormField('vendor')
            }
          } else {
            this.handleAutocompleteChange(selection, 'vendor', true)
            this.previousVendorSelection = { ...this.form.vendor }
          }
        },
        focusOnFirstField () {                                                                                    // Sets DOM focus on the first field, which should ALWAYS have id and ref 'a-1'
          const f = this.$refs['a-1']
          if (f && f[0]) {
            const el = f[0].$el
            if (el.tagName === 'INPUT') {
              el.focus()
            } else {
              el.querySelector('input').focus()
            }
          }
        },
        /**
         * Steps through the form element and finds all children where data-type is either autocomplete or select. Then
         * iterates through these fields and removes the dataset properties from the outer/wrapper div and sets them
         * on actual input child element. This makes keyboard nav possible
         */
        initializeFormFields () {
          const fields = this.$refs.headerForm.$el.querySelectorAll(`[data-type="select"]`)
          fields.forEach(field => {
            const data = { ...field.dataset }
            field.removeAttribute('data-type')
            let nestedInputFields = field.getElementsByTagName('input')
            if (nestedInputFields && nestedInputFields.length) {
              nestedInputFields[0].setAttribute('autocomplete', 'force_off')
              nestedInputFields[0].setAttribute('data-type', data.type)
            }
          })
        },
        updateFormError (value) {
          this.errorField = value
        }
      },
      computed: {
        ...mapGetters({
          getPeriodById: 'getPeriodById',
          headerForm: 'getHeaderForm',
          getHeaderFieldByName: 'getHeaderFieldByName',
          getLastSearchResult: 'getLastSearchResult'
        }),
        visible () {
          const visible = this.$store.getters.getModalVisibilityState
          return Object.values(visible).some(v => v.visible)
        },
        calculateRunningTotal () {
          // POs are a special case. Need to take only closed lines and relief lines of partial lines
          // Does not work with older POs (no `referencing_line` field)
          if (this.lines && this.lines.length && this.transactionType === 'po') {
            // Build an object of line statuses for lookup is the most efficient way to lookup self-referencing data.
            let linesStatuses = {}
            this.lines.map(data => {
              const line = data.form || data
              if (line && line.id) linesStatuses[parseInt(line.id)] = line.type || 'NONE'
            })
            // Now add lines that match our criteria.
            let lineAmts = this.lines.map(line => {
              if (line && line.form && !line.deleteLine && line.form.type === 'CLOSED') {
                return line.form.amount_decimal ? parseFloat(line.form.amount_decimal) : 0
              } else if (line && line.form && !line.deleteLine && line.form.type === 'RELIEF') {
                const originalLine = line.form.referencing_line || null
                if (!originalLine) {
                  return 0
                } else {
                  return (linesStatuses[originalLine] === 'PARTIAL' && line.form.amount_decimal) ? parseFloat(line.form.amount_decimal * -1) : 0
                }
              } else if (line && !line.form && !line.deleteLine) {
                return parseFloat(line.amount_decimal)
              } else {
                return 0
              }
            })
            let total = lineAmts.reduce((sum, lineAmt) => sum + lineAmt)
            return `${total.toFixed(2)}`
          // All other types
          } else if (this.lines && this.lines.length) {
            let lineAmts = this.lines.map(line => {
              if (line && line.form && !line.deleteLine) {
                return line.form.amount_decimal ? parseFloat(line.form.amount_decimal) : 0
              } else if (line && !line.form && !line.deleteLine) {
                return parseFloat(line.amount_decimal)
              } else {
                return 0
              }
            })
            let total = lineAmts.reduce((sum, lineAmt) => sum + lineAmt)
            return `${total.toFixed(2)}`
          } else {
            return '0.00'
          }
        }
      },
      watch: {
        visible () {
          this.suppressKeyNav = this.visible
        }
      },
      created () {
        if (this.form && this.form.hasOwnProperty('vendor')) {
          this.previousVendorSelection = { ...this.form.vendor }
        }
      },
      mounted () {
        this.initializeFormFields()
        // this.focusOnFirstField()
      }
    }
  </script>
  
  <style>
    td input {
      border: none !important;
      height: 22px !important;
    }
    td textarea {
      border: none !important;
      height: 22px !important;
    }
    .el-autocomplete {
      width: 100%;
    }
    .autocomplete-input_required input {
      background-color: #e2f0f5;
    }
    .text-input_required input {
      background-color: #e2f0f5;
    }
  </style>
  
  <style scoped>
    /*Table style properties*/
    table {
      width: 100%;
      margin-bottom: 1em;
      border-collapse: collapse;
    }
    td {
      padding: 0.2em;
      border: 1px solid #ccc;
      background-color: #ffffff;
      font-size: 12px;
    }
    td:first-child {
      text-align: right;
      background-color: #efefef;
      padding: 3px;
    }
    td:nth-child(2) {
      text-align: left;
    }
    td:nth-child(3) {
      text-align: right;
      background-color: #efefef;
      padding: 3px;
    }
    td:nth-child(4) {
      text-align: left;
    }
    .el-table .modified-row {
      background: #c9e5f5;
    }
    .form-checkbox {
      padding: 0 10px;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/HeaderFieldsNew.vue